import React from 'react';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import CenterUnderline from '../common/CenterUnderline';

export default function ContactInfo() {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Kontakt os</h3>
      <p className="mb-4">
        Du er altid mere end velkommen til at kontakte os, enten på mail eller telefonisk.
      </p>
      <ul className="space-y-2">
        <li className="flex items-center gap-2">
          <FaPhone className="w-4 h-4" />
          <CenterUnderline
            label="+45 23 32 15 33"
            onClick={() => window.location.href = 'tel:+4523321533'}
            className="text-white hover:text-yellow-200"
          />
        </li>
        <li className="flex items-center gap-2">
          <FaPhone className="w-4 h-4" />
          <CenterUnderline
            label="+45 28 19 50 77"
            onClick={() => window.location.href = 'tel:+4528195077'}
            className="text-white hover:text-yellow-200"
          />
        </li>
        <li className="flex items-center gap-2">
          <FaEnvelope className="w-4 h-4" />
          <CenterUnderline
            label="brian@bennyspolsevogn.dk"
            onClick={() => window.location.href = 'mailto:brian@bennyspolsevogn.dk'}
            className="text-white hover:text-yellow-200"
          />
        </li>
      </ul>
    </div>
  );
}